export { TemplateInstance } from './template-instance.js';
export { parse } from './template-string-parser.js';
export { AttributeTemplatePart, AttributeValueSetter } from './attribute-template-part.js';
export { NodeTemplatePart } from './node-template-part.js';
export { createProcessor, processPropertyIdentity, processBooleanAttribute, propertyIdentity, propertyIdentityOrBooleanAttribute } from './processors.js';
//# sourceMappingURL=index.js.map